import { Component, SecurityContext } from '@angular/core'
import {
  AuthService,
  AuthStorageService,
  CurrencyService,
  GlobalMessageService,
  GlobalMessageType,
  SiteContextActions,
} from '@spartacus/core'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { QuoteCartService } from './features/quote/quote-services/quote-cart.service'
// import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { CommonService } from './shared/services/common.service'
import { ChangeCustAccountService } from './features/user/change-cust-account/change-cust-account.service'
import { Store } from '@ngrx/store'
import { filter, take } from 'rxjs/operators'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from './features/config/dialog.config'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'vs-spartacus'
  public data: any
  loggedIn: boolean
  userType: string
  cartId: string
  count = 0
  prevBool = false

  // timeout code
  idleState = 'Not started.'
  idleTimeoutStart = false
  timedOut = false
  lastPing?: Date = null

  constructor(
    public auth: AuthService,
    public quoteService: QuoteCartService,
    public authStorageService: AuthStorageService,
    // private idle: Idle,
    // private keepalive: Keepalive
    private launchDialogService: LaunchDialogService,
    private currencyService: CurrencyService,
    private changeCustAccountService: ChangeCustAccountService,
    private globalMessageService: GlobalMessageService,
    private commonService: CommonService,
    protected store: Store<any>,
    private activeCartFacade: ActiveCartFacade,
    private multiCartFacade: MultiCartFacade,
    private sanitizer: DomSanitizer
  ) {
    this.auth.isUserLoggedIn().subscribe(
      (success: any) => {
        this.loggedIn = success
        if (this.loggedIn) {
          this.userType = 'current'
          sessionStorage.removeItem('userType-anonymous')
          sessionStorage.removeItem('cartId-anonymous')
          sessionStorage.removeItem('cartStatus-anonymous')
          /* if (this.loggedIn != this.prevBool) {
          this.setIdleTimerSettings();
        } */
          this.activeCartFacade
            .getActive()
            .pipe(take(1))
            .subscribe((cart) => {
              if (!cart?.code) {
                this.multiCartFacade.createCart({
                  userId: this.userType,
                  oldCartId: cart.code,
                  extraData: {
                    active: true,
                  },
                })
              }
            })
          this.setIdleTimerSettings()
        }
        if (!this.loggedIn) {
          this.userType = 'anonymous'
          sessionStorage.removeItem('userType-current')
          sessionStorage.removeItem('cartId-current')
          sessionStorage.removeItem('cartStatus-current')
        }

        this.cartId =
          sessionStorage.getItem('cartId-' + this.userType) || undefined
        sessionStorage.setItem('userType-' + this.userType, this.userType)

        // Logic to fetch quote data only once after login
        if (!this.loggedIn || this.loggedIn != this.prevBool) {
          if (this.loggedIn) {
            this.changeCustAccountService
              .getCustomerAccDetails()
              .subscribe((response) => {
                if (response !== null && response !== undefined) {
                  if (response['b2bUnits'] !== undefined) {
                    if (response['b2bUnits'].length > 0) {
                      response['b2bUnits']?.forEach((unit) => {
                        if (unit.isDefaultB2bUnit) {
                          this.store.dispatch(
                            new SiteContextActions.SetActiveCurrency(
                              unit?.currency?.isocode
                            )
                          )
                          this.getQuoteCart()
                        }
                      })
                    }
                  }
                }
              })
          } else this.getQuoteCart()
        }
        this.prevBool = this.loggedIn
      },
      (error) => {}
    )
  }

  setIdleTimerSettings() {
    // // Timeout code
    // // sets an idle timeout of 30 mins, for testing purposes.
    // this.idle.setIdle(3600)
    // // sets a timeout period of 30 mins. after 60 seconds of inactivity, the user will be considered timed out.
    // this.idle.setTimeout(60)
    // // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    // this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES)

    // this.idle.onIdleEnd.subscribe(() => {
    //   this.idleState = 'No longer idle.'
    //   this.reset()
    // })

    // this.idle.onTimeout.subscribe(() => {
    //   this.idleState = 'Timed out!'
    //   this.timedOut = true
    //   this.logout()
    // })

    // this.idle.onIdleStart.subscribe(() => {
    //   this.idleState = "You've gone idle!"
    //   this.idle.stop()
    //   this.openSessionTimeoutDialog()
    // })

    // this.idle.onTimeoutWarning.subscribe((countdown) => {
    //   this.idleState = 'You will time out in ' + countdown + ' seconds!'
    // })

    // Sets idle watchers
    this.reset()
  }

  reset() {
    // this.idle.watch()
    this.idleState = 'Started.'
    this.timedOut = false
  }

  openSessionTimeoutDialog() {
    const componentdata = {
      timeout: 60,
    }
    const idleTimeoutModalRef = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.IDLE_TIMEOUT,
      undefined,
      undefined,
      componentdata
    )
    if (idleTimeoutModalRef) {
      idleTimeoutModalRef.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.IDLE_TIMEOUT
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value.reason == 'logout') {
            this.idleState = 'Timed out!'
            this.timedOut = true
            this.logout()
          } else {
            this.reset()
          }
        })
    }
  }

  getQuoteCart() {
    this.count += 1
    if (this.count == 5) {
      return
    }
    this.quoteService.getCart(this.cartId, this.userType).subscribe(
      (cart: any) => {
        if (this.userType === 'current') {
          this.cartId = cart['code']
        } else {
          this.cartId = cart?.['guid']
        }
        sessionStorage.setItem('cartId-' + this.userType, this.cartId)
        if (cart?.entries?.length > 0) {
          sessionStorage.setItem('cartStatus-' + this.userType, 'added')
        } else {
          sessionStorage.setItem('cartStatus-' + this.userType, 'empty')
        }
        sessionStorage.setItem(
          'quoteCart-requestedDate',
          new Date().toISOString()
        )
        return
      },
      (error) => {
        this.cartId = undefined
        this.getQuoteCart()
      }
    )
  }

  logout() {
    // this.idle.stop()
    this.authStorageService.getToken().subscribe(
      (data) => {
        if (data && data.access_token) {
          if (data.access_token) {
            const urlParams = ['vslogin', 'revoke', data.access_token]
            const loginUrl = this.commonService.constructUrl(urlParams)
            this.commonService.getData_Text(loginUrl).subscribe(
              (res: any) => {
                if (res) {
                  localStorage.clear()
                  let returnUrl = res?.split('?')[1]?.split('=')[1]
                  returnUrl = returnUrl
                    ? returnUrl
                    : this.sanitizer.sanitize(
                        SecurityContext.URL,
                        window.location.origin
                      )
                  window.location.href = this.sanitizer.sanitize(
                    SecurityContext.URL,
                    returnUrl
                  )
                } else {
                  /* this.globalMessageService.add(
                  'Something went wrong on logout.',
                  GlobalMessageType.MSG_TYPE_ERROR,
                  10000
                ); */
                }
              },
              (err) => {
                /* this.globalMessageService.add(
                'Something went wrong on logout.',
                GlobalMessageType.MSG_TYPE_ERROR,
                10000
              ); */
              }
            )
          }
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
}
